import { api, toList } from '../apiClient';

export const feedbackService = {
  /** POST /feedback — works for guests and authenticated users */
  submit: (data) => api.post('/feedback', data),

  /** GET /feedback/admin — admin only */
  getAll: (params = {}) => api.get('/feedback/admin', { params }),

  /** PATCH /feedback/admin/:id — update status / add notes */
  resolve: (id, data) => api.patch(`/feedback/admin/${id}`, data),

  /** GET /feedback/admin/count-new — unread badge count */
  countNew: () => api.get('/feedback/admin/count-new'),
};
